module.exports = __webpack_public_path__ + "img/multi_roturas.76a054eb.svg";